<style lang="less">
.left-menu {
  width: 210px;
  z-index: 2;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.25);
  transition: background-color 0.3s ease-in-out;

  .ivu-menu-item-selected {
    background: rgb(237, 237, 237);
  }
}

.ivu-menu-vertical .ivu-menu-submenu-title {
  padding: 10px 24px;
}

.ivu-menu-vertical .ivu-menu-item {
  padding: 8px 24px;
}

.ivu-menu-vertical.ivu-menu-light:after {
  width: 0px;
}

.left-menu .hr-menu-badge {
  display: inline-block;
  min-width: 16px;
  margin-left: 6px;
  padding: 0 5px;
  border-radius: 8px;
  background: #E6464E !important;
  color: #fff !important;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  vertical-align: 1px;
}

/* 三级菜单缩进：智能人事 → 员工管理/员工关系 → 叶子 */
.left-menu .ivu-menu-submenu .ivu-menu-submenu > .ivu-menu-submenu-title {
  padding-left: 36px !important;
}
.left-menu .ivu-menu-submenu .ivu-menu-submenu .ivu-menu-item {
  padding-left: 52px !important;
}
</style>
<template>
  <Menu
    ref="sideMenu"
    :theme="theme"
    :activeName="currentMenu"
    :openNames="openNames"
    width="210px"
    class="left-menu"
    :accordion="false"
    @on-open-change="onOpenChange"
    @on-select="onSelect"
  >
    <template v-for="menuGroup in menuGroups">
      <template v-if="menuGroup.hasPermission">
        <Submenu :name="menuGroup.name" v-if="!menuGroup.url">
          <template slot="title">
            <Icon v-if="menuGroup.icon" :type="menuGroup.icon"></Icon>
            {{ menuGroup.name }}
          </template>
          <template v-for="menuItem in menuGroup.menuItems">
            <Submenu v-if="menuItem.hasPermission && menuItem.subItems" :name="menuItem.name" :key="'sub-'+menuItem.name">
              <template slot="title">{{ menuItem.name }}</template>
              <Menu-item v-for="child in menuItem.subItems" v-if="child.hasPermission" :name="child.name" :key="child.name">
                {{ child.name }}<span v-if="hrBadgeCount(child)" class="hr-menu-badge">{{ hrBadgeCount(child) }}</span>
              </Menu-item>
            </Submenu>
            <Menu-item :name="menuItem.name" v-else-if="menuItem.hasPermission" :key="menuItem.name">
              {{ menuItem.name }}<span v-if="hrBadgeCount(menuItem)" class="hr-menu-badge">{{ hrBadgeCount(menuItem) }}</span>
            </Menu-item>
          </template>
        </Submenu>
        <Menu-item :name="menuGroup.name" v-else>
          {{ menuGroup.name }}
        </Menu-item>
      </template>
    </template>
  </Menu>
</template>
<script>
import { badgesAdviserParam } from '../hrWorkbench/constants'
import matcher from 'matcher'
import { fetchAiAllowed } from '@/tools/aiAccess'

export default {
  name: 'LeftMenu',
  watch: {
    '$route' (to, from) {
      this.currentMenu = this.selectMenu(to)
      this.ensureOpenParents(to)
      if (this.isHrWorkbenchRoute(to) !== this.isHrWorkbenchRoute(from)) {
        this.loadHrBadges()
      }
      if (this.isRecruitRoute(to) !== this.isRecruitRoute(from)) {
        this.loadRecruitBadges()
      }
    }
  },
  data () {
    return {
      theme: 'primary',
      currentMenu: '',
      hrBadges: {
        supervise: 0,
        probation: 0,
        review: 0,
        contract: 0,
        followup: 0
      },
      recruitBadges: {
        interviewing: 0,
        reserved: 0
      },
      menuGroups: [
        {
          hasPermission: false,
          name: '首页',
          icon: 'person-stalker',
          url: '/index',
          menuItems: []
        },
        {
          hasPermission: false,
          name: '市场管理',
          icon: 'person-stalker',
          menuItems: [
            {
              hasPermission: false,
              name: '渠道管理',
              url: '/market/channelManagement'
            },
            {
              hasPermission: false,
              name: '渠道成交率',
              url: '/market/ChannelDealRate'
            },
            {
              hasPermission: false,
              name: '文章发布表',
              url: '/market/ArticlePublishList'
            },
            {
              hasPermission: false,
              name: '发布渠道收录表',
              url: '/market/ChannelIncludeList'
            },
            {
              hasPermission: false,
              name: 'AI渠道收录表',
              url: '/market/AiChannelIncludeList'
            },
            {
              hasPermission: false,
              name: '活动列表',
              url: '/market/activityList'
            }, {
              hasPermission: false,
              name: '分享有礼海报管理',
              url: '/market/shareManagement'
            }, {
              hasPermission: false,
              name: '兑换课程审核',
              url: '/market/exChangeRecordListB'
            },
            {
              hasPermission: false,
              name: '代理管理',
              subItems: [
                {
                  hasPermission: false,
                  name: '代理用户',
                  url: '/agent/agentUserList'
                }, {
                  hasPermission: false,
                  name: '推荐记录',
                  url: '/agent/agentInviteList'
                }
              ]
            },
          ]
        },
        {
          hasPermission: false,
          name: 'crm',
          icon: 'person-stalker',
          menuItems: [
            {
              hasPermission: false,
              name: '个人资源',
              url: '/crm/MyResource'
            }, {
              hasPermission: false,
              name: '打卡分单',
              url: '/crm/adviserPunchList'
            }, {
              hasPermission: false,
              name: '分配记录',
              url: '/crm/DistributionList'
            }, {
              hasPermission: false,
              name: '首次跟踪记录',
              url: '/crm/FirstFollowList'
            }, {
              hasPermission: false,
              name: '今日将转出名单',
              url: '/crm/dailyTransferList'
            }, {
              hasPermission: false,
              name: '公共资源',
              url: '/crm/TreasuryResource'
            }, {
              hasPermission: false,
              name: '拼团记录',
              url: '/crm/SpellGroupList'
            }, {
              hasPermission: false,
              name: '销售通话记录',
              url: '/crm/PhoneRecordList'
            }, {
              hasPermission: false,
              name: '销售通话记录AI',
              url: '/crm/DviAudioList'
            }, {
              hasPermission: false,
              name: '通话转写词表',
              url: '/crm/CallAsrWord'
            }, {
              hasPermission: false,
              name: '销售话术库',
              url: '/crm/CallScript'
            }]
        },
        {
          hasPermission: false,
          name: '学生管理',
          icon: 'happy-outline',
          menuItems: [
            {
              hasPermission: false,
              name: '体验名单',
              url: '/user/bookTestList'
            }, {
              hasPermission: false,
              name: '体验学生',
              url: '/user/userExperienceList'
            }, {
              hasPermission: false,
              name: '待分配学生',
              url: '/user/userProvisionalList'
            }, {
              hasPermission: false,
              name: '常规学生',
              url: '/user/userPayList'
            }, {
              hasPermission: false,
              name: '新生分配',
              url: '/user/userTodayNewList'
            }, {
              hasPermission: false,
              name: '学情反馈',
              url: '/user/newStudentService'
            },
            {
              hasPermission: false,
              name: '课时流水',
              url: '/user/classHourFlow'
            },
            {
              hasPermission: false,
              name: '学员跟踪记录',
              url: '/user/userTrackList'
            }, {
              hasPermission: false,
              name: '学员风险',
              url: '/user/studentRiskList'
            }, {
              hasPermission: false,
              name: '学生请假列表',
              url: '/user/bookUserLeaveTimeList'
            },
            {
              hasPermission: false,
              name: '学生状态审核',
              url: '/user/UserStatusAuditList'
            }, {
              hasPermission: false,
              name: '补课时记录',
              url: '/user/bookCourseChangeList'
            }, {
              hasPermission: false,
              name: 'followUp记录',
              url: '/user/followUpList'
            }, {
              hasPermission: false,
              name: '朋友圈分享审核列表',
              url: '/user/activityExamineList'
            }, {
              hasPermission: false,
              name: '兑换记录',
              url: '/user/exchangeRecordList'
            }, {
              hasPermission: false,
              name: '退费学生列表',
              url: '/user/userRefundList'
            }, {
              hasPermission: false,
              name: '结课学生列表',
              url: '/user/userOverClassList'
            }, {
              hasPermission: false,
              name: '停课学生列表',
              url: '/user/userLessonsStopList'
            }, {
              hasPermission: false,
              name: '禁用学生列表',
              url: '/user/userNotAllowedList'
            },
            {
              hasPermission: false,
              name: '每日作业',
              url: '/bookMaterialLessons/dailyStudy'
            },
            {
              hasPermission: false,
              name: '取消课程记录',
              url: '/user/cancelLessonRecord'
            },
            // {
            //   hasPermission: false,
            //   name: '打卡闯关列表',
            //   url: '/user/reviewClockRecordList'
            // },
            {
              hasPermission: false,
              name: '分配学导记录',
              url: '/user/DistributionStudyRecord'
            },
            {
              hasPermission: false,
              name: '周数据',
              url: '/user/StudentWeekStatList'
            },
            {
              hasPermission: false,
              name: '月数据',
              url: '/user/StudentMonthStatList'
            },
            {
              hasPermission: false,
              name: '修改绑定记录',
              url: '/user/BindTeacherOperationRecord'
            },
            {
              hasPermission: false,
              name: '绑定分组课件修复',
              url: '/user/bindGroupLessonScan'
            },
            {
              hasPermission: false,
              name: '多级别绑定等级',
              url: '/user/bindGroupLevel'
            },
            {
              hasPermission: false,
              name: '单词卡',
              url: '/user/wordCardList'
            },
            {
              hasPermission: false,
              name: '句子翻译',
              url: '/user/sentenceCardList'
            },
            {
              hasPermission: false,
              name: '学生单词本',
              url: '/user/studentWordbookList'
            },
            {
              hasPermission: false,
              name: '跟读记录',
              url: '/user/studentWordcardEvalList'
            },
            {
              hasPermission: false,
              name: '异动老师',
              url: '/tch/tchAnomalyList'
            },
            {
              hasPermission: false,
              name: '异动老师看板',
              url: '/user/tchRebindBoard'
            }
          ]
        },
        {
          hasPermission: false,
          name: '老师管理',
          icon: 'person',
          menuItems: [
            {
              hasPermission: false,
              name: '外教招聘',
              subItems: [
                {
                  hasPermission: false,
                  name: '数据看板',
                  url: '/tch/recruit/dashboard'
                },
                {
                  hasPermission: false,
                  name: '招聘培训统计',
                  url: '/tch/recruitTrainStat'
                },
                {
                  hasPermission: false,
                  name: '待审核老师',
                  url: '/tch/tchUnauditedList'
                },
                {
                  hasPermission: false,
                  name: '已审核老师',
                  url: '/tch/tchAuditList'
                },
                {
                  hasPermission: false,
                  name: '待面试老师',
                  url: '/tch/recruit/pendingInterview',
                  recruitBadgeKey: 'interviewing'
                },
                {
                  hasPermission: false,
                  name: '招聘龙虎榜',
                  url: '/tch/recruit/leaderboard'
                },
                {
                  hasPermission: false,
                  name: '注册渠道管理',
                  url: '/tch/regChannelList'
                },
                {
                  hasPermission: false,
                  name: '推荐官管理',
                  url: '/tch/referrerList'
                },
                {
                  hasPermission: false,
                  name: '被推荐人管理',
                  url: '/tch/referrerFeeList'
                },
                {
                  hasPermission: false,
                  name: '储备老师',
                  url: '/tch/recruit/reserved',
                  recruitBadgeKey: 'reserved'
                }
              ]
            },
            {
              hasPermission: false,
              name: '外教管理',
              subItems: [
                {
                  hasPermission: false,
                  name: '培训中老师',
                  url: '/tch/trainingList'
                },
                {
                  hasPermission: false,
                  name: '正式老师',
                  url: '/tch/tchFormalList'
                },
                {
                  hasPermission: false,
                  name: '正式老师(菲)',
                  url: '/tch/filipino/tchFormalList'
                },
                {
                  hasPermission: false,
                  name: '课堂投诉',
                  url: '/tch/tchComplaintList'
                },
                {
                  hasPermission: false,
                  name: '外教对接中心',
                  url: '/tch/foreignTchMatchCenter'
                },
                {
                  hasPermission: false,
                  name: '上课异常列表',
                  url: '/tch/tchOpenedExceptionList'
                },
                {
                  hasPermission: false,
                  name: '离职外教',
                  url: '/tch/tchResignFormalList'
                },
                {
                  hasPermission: false,
                  name: '老师请假列表',
                  url: '/tch/tchLeaveList'
                },
                {
                  hasPermission: false,
                  name: '优秀外教排行榜',
                  url: '/tch/tchTeacherRanking'
                },
                {
                  hasPermission: false,
                  name: '外教核心数据看板',
                  url: '/tch/tchHrMetricsDashboard'
                },
                {
                  hasPermission: false,
                  name: '外教异动风险监测',
                  url: '/tch/tchRiskWarningList'
                },
                {
                  hasPermission: false,
                  name: '在职老师请假率',
                  url: '/tch/tchLeaveRateList'
                }
              ]
            },
            {
              hasPermission: false,
              name: '外管工作台',
              subItems: [
                {
                  hasPermission: false,
                  name: '在职老师',
                  url: '/tch/tchNormalList'
                },
                {
                  hasPermission: false,
                  name: '主管管理',
                  url: '/hrWorkbench/supervise',
                  badgeKey: 'supervise'
                },
                {
                  hasPermission: false,
                  name: '工作台',
                  url: '/hrWorkbench/dashboard'
                },
                {
                  hasPermission: false,
                  name: '试用期到期提醒',
                  url: '/hrWorkbench/probation',
                  badgeKey: 'probation'
                },
                {
                  hasPermission: false,
                  name: '新外教跟进',
                  url: '/hrWorkbench/review',
                  badgeKey: 'review'
                },
                {
                  hasPermission: false,
                  name: '合同到期提醒',
                  url: '/hrWorkbench/contract',
                  badgeKey: 'contract'
                },
                {
                  hasPermission: false,
                  name: '出勤风险跟进',
                  url: '/hrWorkbench/followup',
                  badgeKey: 'followup'
                }
              ]
            },
            {
              hasPermission: false,
              name: 'Tutor Page管理',
              subItems: [
                {
                  hasPermission: false,
                  name: '开课Checklist管理',
                  url: '/tch/onboardingManage'
                },
                {
                  hasPermission: false,
                  name: '外教中心展示资料',
                  url: '/tch/learningMaterialList'
                },
                {
                  hasPermission: false,
                  name: '外管消息',
                  url: '/tch/messageCenter'
                }
              ]
            },
            {
              hasPermission: false,
              name: '其他操作记录',
              subItems: [
                {
                  hasPermission: false,
                  name: '老师签到日志',
                  url: '/tch/tchSignLogList'
                },
                {
                  hasPermission: false,
                  name: '签到记录',
                  url: '/tch/tchSignTimeList'
                },
                {
                  hasPermission: false,
                  name: '外教首课签到',
                  url: '/tch/tchFirstCheckList'
                },
                {
                  hasPermission: false,
                  name: '异常操作日志',
                  url: '/tch/tchExceptionLogList'
                },
                {
                  hasPermission: false,
                  name: '老师跟踪记录',
                  url: '/tch/tchTrackList'
                },
                {
                  hasPermission: false,
                  name: '老师考勤',
                  url: '/tch/tchAttendanceList'
                },
                {
                  hasPermission: false,
                  name: '老师考勤明细',
                  url: '/tch/tchAttendanceDetailList'
                }
              ]
            },
            /* Excel 未列：仍挂老师管理根下，不删 */
            {
              hasPermission: false,
              name: '老师工资条',
              url: '/tch/tchWagesList'
            },
            {
              hasPermission: false,
              name: '外管绩效',
              url: '/tch/tchPerformanceList'
            },
            {
              hasPermission: false,
              name: '外管数据',
              url: '/tch/tchForeignManageData'
            },
            {
              hasPermission: false,
              name: '老师反馈记录',
              url: '/tch/tchFeedbackList'
            },
            {
              hasPermission: false,
              name: '外教开课Checklist',
              url: '/tch/onboardingChecklist'
            },

          ]
        },
        {
          hasPermission: false,
          name: '智能人事',
          icon: 'ios-people',
          menuItems: [
            {
              hasPermission: false,
              name: '员工管理',
              subItems: [
                { hasPermission: false, name: '花名册', url: '/smartHr/roster' },
                { hasPermission: false, name: '用工安全', url: '/smartHr/safety' }
              ]
            },
            {
              hasPermission: false,
              name: '员工关系',
              subItems: [
                { hasPermission: false, name: '入职管理', url: '/smartHr/onboarding' },
                { hasPermission: false, name: '新人成长', url: '/smartHr/growth' },
                { hasPermission: false, name: '转正管理', url: '/smartHr/regularization' },
                { hasPermission: false, name: '异动管理', url: '/smartHr/transfer' },
                { hasPermission: false, name: '离职管理', url: '/smartHr/resignation' },
                { hasPermission: false, name: '合同管理', url: '/smartHr/contract' },
                { hasPermission: false, name: '退休管理', url: '/smartHr/retire' },
                { hasPermission: false, name: '员工关怀', url: '/smartHr/care' }
              ]
            }
          ]
        },
        {
          hasPermission: false,
          name: '学生风险看板',
          icon: 'stats-bars',
          menuItems: [
            {
              hasPermission: false,
              name: '影响总览',
              url: '/tchImpact/overview'
            },
            {
              hasPermission: false,
              name: '学生异动影响',
              url: '/tchImpact/change'
            },
            {
              hasPermission: false,
              name: '请假/旷课影响',
              url: '/tchImpact/leave'
            },
            {
              hasPermission: false,
              name: '学生影响明细',
              url: '/tchImpact/student'
            },
            {
              hasPermission: false,
              name: '综合风险视图',
              url: '/tchImpact/risk'
            },
            {
              hasPermission: false,
              name: '指标口径',
              url: '/tchImpact/model'
            }
          ]
        },
        {
          hasPermission: false,
          name: '约课管理',
          icon: 'compose',
          menuItems: [
            {
              hasPermission: false,
              name: '色块排课表',
              url: '/lesson/timetableList'
            }, {
              hasPermission: false,
              name: '常规课程列表',
              url: '/lesson/bookLessonOpenedList'
            }, {
              hasPermission: false,
              name: '实时监课',
              url: '/lesson/liveMonitor'
            }, {
              hasPermission: false,
              name: '已结束课表',
              url: '/lesson/bookLessonFinishedList'
            }, {
              hasPermission: false,
              name: 'classin临时账号',
              url: '/lesson/bookClassinList'
            }, {
              hasPermission: false,
              name: '老师代课记录',
              url: '/lesson/ReplaceRecord'
            }, {
              hasPermission: false,
              name: '当天订课信息',
              url: '/lesson/bookLessonTempList'
            },
            {
              hasPermission: false,
              name: '体验课上课要求',
              url: '/tch/trialLessonRequirements'
            }
          ]
        },
        {
          hasPermission: false,
          name: '审批管理',
          icon: 'compose',
          menuItems: [
            {
              hasPermission: false,
              name: '修改绑定审批',
              url: '/auditList'
            },
            {
              hasPermission: false,
              name: '修改绑定解冻',
              url: '/bindUnfreezeAuditList'
            }
          ]
        },
        {
          hasPermission: false,
          name: '教研题库',
          icon: 'ios-bookmarks',
          menuItems: [
            {
              hasPermission: false,
              name: '等级测试',
              subItems: [
                {
                  hasPermission: false,
                  name: '等级测试列表',
                  url: '/level/levelGradeList'
                }, {
                  hasPermission: false,
                  name: '测试题列表',
                  url: '/level/levelQuestionList'
                }, {
                  hasPermission: false,
                  name: '测试结果',
                  url: '/level/levelRecordList'
                }, {
                  hasPermission: false,
                  name: '课后结果',
                  url: '/level/reviewRecore'
                }
              ]
            },
            {
              hasPermission: false,
              name: '课程管理',
              subItems: [
                {
                  name: '公开课',
                  url: '/course/openClassList'
                }, {
                  name: '单节课列表',
                  url: '/course/bookLessonList'
                }, {
                  name: '等级列表',
                  url: '/course/materialLevelList'
                }, {
                  hasPermission: false,
                  name: 'classin文件目录',
                  url: '/course/classinFolder'
                }, {
                  hasPermission: false,
                  name: '课后习题',
                  url: '/course/classReview'
                },
                {
                  hasPermission: false,
                  name: '课前课后题目',
                  url: '/course/lessonSubject'
                },
                {
                  hasPermission: false,
                  name: '课前预习',
                  url: '/course/lessonPreviewList'
                },
                {
                  hasPermission: false,
                  name: '课后视频',
                  url: '/course/lessonVideoList'
                },
                {
                  hasPermission: false,
                  name: '课程音频',
                  url: '/course/lessonAudioList'
                },
                {
                  hasPermission: false,
                  name: '教材价格列表',
                  url: '/course/coursePriceList'
                },
                {
                  hasPermission: false,
                  name: '教材报错',
                  url: '/course/BookMaterialLessonsErr'
                }
          
              ]
            },
            {
              hasPermission: false,
              name: '机侧题库',
              subItems: [
                {
                  hasPermission: false,
                  name: '综合题库',
                  url: '/mex/comp/questions'
                },
                {
                  hasPermission: false,
                  name: '口语题库',
                  url: '/mex/speak/questions'
                },
                {
                  hasPermission: false,
                  name: '蓝图',
                  url: '/mex/blueprints'
                },
                {
                  hasPermission: false,
                  name: '试做试卷',
                  url: '/mex/trial'
                },
                {
                  hasPermission: false,
                  name: '场次记录',
                  url: '/mex/sessions'
                },
                {
                  hasPermission: false,
                  name: '题目反馈',
                  url: '/mex/feedback'
                },
                {
                  hasPermission: false,
                  name: '升班建议',
                  url: '/mex/promotions'
                },
                {
                  hasPermission: false,
                  name: '学习建议',
                  url: '/mex/advice'
                },
                {
                  hasPermission: false,
                  name: '实测统计',
                  url: '/mex/stats'
                },
                {
                  hasPermission: false,
                  name: '同龄分群',
                  url: '/mex/cohorts'
                },
                {
                  hasPermission: false,
                  name: '灰度设置',
                  url: '/mex/gray'
                }
          
              ]
            }
          ]
        },
        {
          hasPermission: false,
          name: '题库',
          icon: 'archive',
          menuItems: [
            {
              hasPermission: false,
              name: '英语能力信息列表',
              url: '/question/abilityList'
            }, {
              hasPermission: false,
              name: '机测等级题目页面',
              url: '/question/abilityList'
            }, {
              hasPermission: false,
              name: '题目模板管理',
              url: '/question/templateList'
            }]
        },
        {
          hasPermission: false,
          name: '订单管理',
          icon: 'clipboard',
          menuItems: [
            {
              name: '订单列表',
              url: '/order/fundPackageList'
            },
            {
              hasPermission: false,
              name: '龙虎榜',
              url: '/order/dragonTigerListV2'
            },
            {
              hasPermission: false,
              name: '班主任龙虎榜',
              url: '/order/studyAdviserDragonTiger'
            },
            {
              hasPermission: false,
              name: '业绩统计',
              url: '/order/performanceList'
            },
            {
              hasPermission: false,
              name: '销售成交率',
              url: '/crm/SalesDealRate'
            },
            {
              hasPermission: false,
              name: '合同模板',
              url: '/data/contract-version'
            }
          ]
        },
        {
          hasPermission: false,
          name: '财务管理',
          icon: 'social-yen',
          menuItems: [
            {
              hasPermission: false,
              name: '应开发票',
              url: '/financial/InvoiceList'
            },
            {
              hasPermission: false,
              name: '收入统计',
              url: '/financial/IncomeStatistics'
            },
            {
              hasPermission: false,
              name: '退费列表',
              url: '/financial/refundList'
            },
            {
              hasPermission: false,
              name: '班主任退费看板',
              url: '/financial/studyAdviserRefundDashboard'
            },
            {
              hasPermission: false,
              name: '资金管理',
              subItems: [
                {
                  name: '用户账单',
                  url: '/fund/fundUserBillList'
                }
              ]
            },
          ]
        },
        {
          hasPermission: false,
          name: '系统',
          icon: 'gear-a',
          menuItems: [
            {
              hasPermission: false,
              name: '管理员列表',
              url: '/adminUser/adminUserList'
            }, {
              hasPermission: false,
              name: '权限组管理',
              url: '/adminGroup/adminGroupList'
            }, {
              hasPermission: false,
              name: '权限菜单列表',
              url: '/adminGroup/adminRuleList'
            }, {
              hasPermission: false,
              name: '配置管理',
              url: '/admin/adminConfigList'
            }, {
              hasPermission: false,
              name: '自动排课配置',
              url: '/admin/adminTConfigList'
            }, {
              hasPermission: false,
              name: '短信群发',
              url: '/admin/sendSms'
            }
          ]
        },
        {
          hasPermission: false,
          name: '日常辅助',
          icon: 'wrench',
          menuItems: [
            {
              hasPermission: false,
              name: '班主任值班表',
              url: '/adminUser/StudyDutyList'
            },
            {
              hasPermission: false,
              name: '操作日志',
              url: '/adminUser/LogList'
            },
            {
              hasPermission: false,
              name: '消息模板',
              url: '/adminUser/MessageTemplate'
            },
            {
              hasPermission: false,
              name: '消息日志',
              url: '/adminUser/MessageLog'
            },
            {
              hasPermission: false,
              name: '短信电话记录',
              url: '/sms/recordList'
            },
            {
              hasPermission: false,
              name: '课时对照',
              url: '/support/classInfoList'
            },
            {
              hasPermission: false,
              name: '总课时充值对照',
              url: '/support/totalClassInfoList'
            },
            {
              hasPermission: false,
              name: '个人站内信',
              url: '/message/personMessage'
            },
            {
              hasPermission: false,
              name: '内部手机号',
              url: '/support/internalMobile'
            },
            {
              hasPermission: false,
              name: '学生临时登录密码',
              url: '/support/studentTempLoginPassword'
            },
            {
              hasPermission: false,
              name: '外教风险地区',
              url: '/support/diplomaticRisk'
            },
            {
              hasPermission: false,
              name: 'IP黑名单',
              url: '/support/ipBlacklist'
            },
          ]
        },
        {
          hasPermission: false,
          name: '数据中心',
          icon: 'wrench',
          menuItems: [
            {
              hasPermission: false,
              name: '老师绩效统计',
              url: '/data/teacherPerformanceList'
            },
            {
              hasPermission: false,
              name: '老师薪酬统计',
              url: '/data/teacherSalaryList'
            },
            {
              hasPermission: false,
              name: '外教课上课统计',
              url: '/data/foreignTeacherDeductionSummary'
            },
            {
              hasPermission: false,
              name: '老师薪酬统计(菲)',
              url: '/data/filipino/teacherSalaryList'
            },
            {
              hasPermission: false,
              name: '老师数据统计',
              url: '/data/tchClassUsageList'
            },
            {
              hasPermission: false,
              name: '老师核心数据',
              url: '/data/teacherMonthlyCoreData'
            },
            {
              hasPermission: false,
              name: '老师使用率',
              url: '/data/tchUsageList'
            },
            {
              hasPermission: false,
              name: '学导跟进数据',
              url: '/data/studyAdviserTrack',
            },
            {
              hasPermission: false,
              name: '课顾跟进数据',
              url: '/data/adviserData',
            },
            {
              hasPermission: false,
              name: '续费数据列表',
              url: '/data/RenewDataList',
            },
            {
              hasPermission: false,
              name: '课耗数据列表',
              url: '/data/LessonExpendDailyList',
            },
            {
              hasPermission: false,
              name: '学生量数据列表',
              url: '/data/StudentDailyList',
            },
            {
              hasPermission: false,
              name: '常规生转化率列表',
              url: '/data/finishRenewalRateList'
            },
            {
              hasPermission: false,
              name: '数据汇总列表',
              url: '/data/statisticsGatherList'
            },
            {
              hasPermission: false,
              name: '销售名单利用数据',
              url: '/data/salesUtilizationList'
            },
            {
              hasPermission: false,
              name: '后端学导数据',
              url: '/data/studyAdviserList'
            },
            {
              hasPermission: false,
              name: '班主任课耗绩效',
              url: '/data/studyAdviserConsumeList'
            },
            {
              hasPermission: false,
              name: '学员生命周期',
              url: '/data/studentLifeCycle'
            },
            {
              hasPermission: false,
              name: '财务每日数据',
              url: '/data/financeDaily',
            },
          ]
        },
        {
          hasPermission: false,
          name: '应急外教池',
          icon: 'person-stalker',
          menuItems: [
            {
              hasPermission: false,
              name: '外教池管理',
              url: '/emergency/teacherPool'
            },
            {
              hasPermission: false,
              name: '试听外教池',
              url: '/emergency/trialTeacherPool'
            }
          ]
        },
        {
          hasPermission: false,
          name: '官网活动',
          icon: 'wrench',
          menuItems: [
            {
              hasPermission: false,
              name: '学生作品管理',
              url: '/activity/UserVideoList'
            },
            {
              hasPermission: false,
              name: '合作平台作品',
              url: '/safenessVote/UserVideoList'
            }
          ]
        },
        {
          hasPermission: false,
          name: '语音合成',
          icon: 'volume-medium',
          menuItems: [
            {
              hasPermission: false,
              name: '音色',
              url: '/speech/voice'
            },
            {
              hasPermission: false,
              name: '合成',
              url: '/speech/compose'
            },
            {
              hasPermission: false,
              name: '成片',
              url: '/speech/clip'
            }
          ]
        },
        {
          hasPermission: false,
          name: '网盘',
          icon: 'folder',
          menuItems: [
            {
              hasPermission: false,
              name: '网盘',
              url: '/disk/index'
            },
            {
              hasPermission: false,
              name: '回收站',
              url: '/disk/recycle'
            },
            {
              hasPermission: false,
              name: '分享记录',
              url: '/disk/shares'
            }
          ]
        },
        {
          hasPermission: false,
          name: '知识库',
          icon: 'ios-book',
          menuItems: [
            {
              hasPermission: false,
              name: '库管理',
              url: '/kb/index'
            }
          ]
        }
      ],
      openNames: []
    }
  },
  mounted: function () {
  },
  created: function () {
    // 默认全收：不恢复 localStorage；只展开当前页父链
    try {
      this.$store.remove('menuOpenNames')
    } catch (e) {}
    this.openNames = []
    this.currentMenu = this.selectMenu(this.$route)
    this.ensureOpenParents(this.$route)

    this.init()
    this.$root.$on('hr-badges-refresh', this.loadHrBadges)
    this.$root.$on('recruit-badges-refresh', this.loadRecruitBadges)
  },
  beforeDestroy: function () {
    this.$root.$off('hr-badges-refresh', this.loadHrBadges)
    this.$root.$off('recruit-badges-refresh', this.loadRecruitBadges)
  },
  methods: {
    init () {
      var self = this
      var ruleReq = this.$http.get('/adminRule/queryUserAllAdminRule')
      var allowReq = fetchAiAllowed(this.$http)
      Promise.all([ruleReq, allowReq]).then(function (results) {
        let res = results[0]
        let allowed = results[1]
        let data = res.data
        let modules = data.filter(item => (item.type === 2) && item.status === 1 && item.havePermission === true)
        self.menuGroups.forEach(menuGroup => {
          modules.filter(child => child.title === menuGroup.name).forEach(child => {
            menuGroup.hasPermission = true
          })

          menuGroup.menuItems.forEach(menuItem => {
            modules.filter(child => child.title === menuItem.name).forEach(child => {
              menuItem.hasPermission = true
              menuGroup.hasPermission = true
            })
            if (menuItem.subItems) {
              menuItem.subItems.forEach(sub => {
                modules.filter(child => child.title === sub.name).forEach(child => {
                  sub.hasPermission = true
                  menuItem.hasPermission = true
                  menuGroup.hasPermission = true
                })
              })
            }
          })
          if (menuGroup.name === '网盘') {
            let diskMenu = menuGroup.menuItems.find(menuItem => menuItem.url === '/disk/index')
            let recycleMenu = menuGroup.menuItems.find(menuItem => menuItem.url === '/disk/recycle')
            let shareMenu = menuGroup.menuItems.find(menuItem => menuItem.url === '/disk/shares')
            if (diskMenu && diskMenu.hasPermission) {
              if (recycleMenu) {
                recycleMenu.hasPermission = true
              }
              if (shareMenu) {
                shareMenu.hasPermission = true
              }
            }
          }
          if (menuGroup.name === '数据中心') {
            let teacherDataMenu = menuGroup.menuItems.find(menuItem => menuItem.name === '老师数据统计')
            let teacherCoreDataMenu = menuGroup.menuItems.find(menuItem => menuItem.name === '老师核心数据')
            let teacherSalaryMenu = menuGroup.menuItems.find(menuItem => menuItem.name === '老师薪酬统计')
            let foreignTeacherDeductionMenu = menuGroup.menuItems.find(menuItem => menuItem.name === '外教课上课统计')
            if (teacherDataMenu && teacherCoreDataMenu && teacherDataMenu.hasPermission) {
              teacherCoreDataMenu.hasPermission = true
              menuGroup.hasPermission = true
            }
            if (teacherSalaryMenu && foreignTeacherDeductionMenu && teacherSalaryMenu.hasPermission) {
              foreignTeacherDeductionMenu.hasPermission = true
              menuGroup.hasPermission = true
            }
          }
        })
        if (!allowed) {
          self.menuGroups.forEach(function (menuGroup) {
            if (!menuGroup.menuItems) {
              return
            }
            menuGroup.menuItems.forEach(function (menuItem) {
              if (menuItem.name === '学员风险') {
                menuItem.hasPermission = false
              }
            })
          })
        }
        self.publishSearchItems()
        if (self.hasHrWorkbenchMenu()) {
          self.loadHrBadges()
        }
        self.loadRecruitBadges()
      })
    },
    // 顶栏菜单搜索只用这里有权限的叶子菜单
    publishSearchItems () {
      let items = []
      let seen = {}
      let add = (name, url, path) => {
        if (!url || seen[url]) return
        seen[url] = true
        items.push({ name: name, url: url, path: path })
      }
      this.menuGroups.forEach(menuGroup => {
        if (!menuGroup.hasPermission) return
        if (menuGroup.url) {
          add(menuGroup.name, menuGroup.url, '')
        }
        (menuGroup.menuItems || []).forEach(menuItem => {
          if (!menuItem.hasPermission) return
          if (menuItem.subItems) {
            menuItem.subItems.forEach(sub => {
              if (sub.hasPermission) {
                add(sub.name, sub.url, menuGroup.name + ' / ' + menuItem.name)
              }
            })
          } else {
            add(menuItem.name, menuItem.url, menuGroup.name)
          }
        })
      })
      this.$root.menuSearchItems = items
      this.$root.$emit('menu-search-items', items)
    },
    findMenuUrl (name) {
      for (let menuGroup of this.menuGroups) {
        for (let menuItem of menuGroup.menuItems || []) {
          if (menuItem.name === name && menuItem.url) return menuItem.url
          if (menuItem.subItems) {
            for (let sub of menuItem.subItems) {
              if (sub.name === name && sub.url) return sub.url
            }
          }
        }
      }
      return ''
    },
    selectMenu (route) {
      if (!route) {
        return
      }
      var path = route.path
      if (!path) {
        this.$logger.debug('path 不存在')
        return
      }
      // 设置焦点菜单
      if (path && path.length > 1 && path.endsWith('/')) {
        path = path.substring(0, path.length - 1)
      }
      for (let menuGroup of this.menuGroups) {
        for (let menuItem of menuGroup.menuItems) {
          if (menuItem.url === path) {
            return menuItem.name
          } else if (menuItem.subItems) {
            for (let sub of menuItem.subItems) {
              if (sub.url === path) {
                return sub.name
              }
            }
          } else if (menuItem.children) {
            for (let pathPattern of menuItem.children) {
              if (matcher.isMatch(path, pathPattern)) {
                return menuItem.name
              }
            }
          }
        }
      }
      return this.selectParentMenu(route)
    },
    selectParentMenu (route) {
      if (!route || !route.path) {
        return
      }
      var path = route.path
      if (path.endsWith('/')) {
        path = path.substring(0, path.length - 1)
      }
      path = path.substring(0, path.lastIndexOf('/'))
      for (let menuGroup of this.menuGroups) {
        for (let menuItem of menuGroup.menuItems) {
          if (menuItem.url === path) {
            return menuItem.name
          }
        }
      }
    },
    onSelect (name) {
      this.menuGroups.forEach(menuGroup => {
        if (menuGroup.url) {
          if (menuGroup.name === name) {
            this.$router.push(menuGroup.url)
            return
          }
        }
        if (!menuGroup.menuItems) {
          return true
        }
        menuGroup.menuItems.forEach(menuItem => {
          if (menuItem.name === name && menuItem.url) {
            this.$router.push(menuItem.url)
            return
          }
          if (menuItem.subItems) {
            menuItem.subItems.forEach(sub => {
              if (sub.name === name && sub.url) {
                this.$router.push(sub.url)
              }
            })
          }
        })
      })
    },
    onOpenChange (names) {
      // iView 原地 splice/push 改 openNames 后会 emit；禁止再赋值，否则 watch 死循环打满 CPU
      if (Array.isArray(names) && names !== this.openNames) {
        this.openNames = names
      }
    },
    ensureOpenParents (route) {
      if (!route || !route.path) return
      let path = route.path
      if (path.length > 1 && path.endsWith('/')) {
        path = path.substring(0, path.length - 1)
      }
      let need = []
      for (let menuGroup of this.menuGroups) {
        for (let menuItem of (menuGroup.menuItems || [])) {
          if (menuItem.url === path) {
            need = [menuGroup.name]
          } else if (menuItem.subItems) {
            for (let sub of menuItem.subItems) {
              if (sub.url === path) {
                need = [menuGroup.name, menuItem.name]
              }
            }
          }
        }
      }
      // 直接设为当前页父链（只开祖先）；无匹配则全收
      let cur = this.openNames || []
      let next = need
      let changed = next.length !== cur.length ||
        next.some(n => cur.indexOf(n) < 0) ||
        cur.some(n => next.indexOf(n) < 0)
      if (changed) {
        this.openNames = next
      }
      this.$nextTick(() => {
        this.syncSubmenuOpened()
      })
    },
    syncSubmenuOpened () {
      let menu = this.$refs.sideMenu
      if (!menu) return
      if (menu.updateOpened) {
        menu.updateOpened()
      }
      // iView updateOpened 只设 opened=true，不关；把不在 openNames 的 Submenu 关掉
      let open = this.openNames || []
      let walk = (vm, out) => {
        ;(vm.$children || []).forEach(c => {
          if (c.$options && c.$options.name === 'Submenu') out.push(c)
          walk(c, out)
        })
        return out
      }
      walk(menu, []).forEach(item => {
        if (open.indexOf(item.name) < 0) {
          item.opened = false
        } else {
          item.opened = true
        }
      })
    },
    isHrWorkbenchRoute (route) {
      let path = (route && route.path) || ''
      return path === '/hrWorkbench' || path.indexOf('/hrWorkbench/') === 0
    },
    isRecruitRoute (route) {
      let path = (route && route.path) || ''
      return path.indexOf('/tch/recruit/') === 0
    },
    hrBadgeCount (menuItem) {
      if (menuItem && menuItem.recruitBadgeKey) {
        return this.hrBadgeNum(this.recruitBadges[menuItem.recruitBadgeKey])
      }
      if (!menuItem || !menuItem.badgeKey) {
        return 0
      }
      let n = Number(this.hrBadges[menuItem.badgeKey])
      if (!isFinite(n) || n <= 0) {
        return 0
      }
      return Math.floor(n)
    },
    hasHrWorkbenchMenu () {
      let groups = this.menuGroups || []
      for (let i = 0; i < groups.length; i++) {
        let items = groups[i].menuItems || []
        for (let j = 0; j < items.length; j++) {
          if (items[j].badgeKey && items[j].hasPermission) {
            return true
          }
          let subs = items[j].subItems || []
          for (let k = 0; k < subs.length; k++) {
            if (subs[k].badgeKey && subs[k].hasPermission) {
              return true
            }
          }
        }
      }
      return false
    },
    loadHrBadges () {
      if (!this.hasHrWorkbenchMenu()) {
        return
      }
      let self = this
      self.$http.post('/tch/hr-workbench/badges', badgesAdviserParam(), { silent: true }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          let d = res.data
          self.hrBadges = {
            supervise: self.hrBadgeNum(d.supervise),
            probation: self.hrBadgeNum(d.probation),
            review: self.hrBadgeNum(d.review),
            contract: self.hrBadgeNum(d.contract),
            followup: self.hrBadgeNum(d.followup)
          }
        }
      })
    },
    hasRecruitBadgeMenu () {
      let groups = this.menuGroups || []
      for (let i = 0; i < groups.length; i++) {
        let items = groups[i].menuItems || []
        for (let j = 0; j < items.length; j++) {
          if (items[j].recruitBadgeKey && items[j].hasPermission) {
            return true
          }
          let subs = items[j].subItems || []
          for (let k = 0; k < subs.length; k++) {
            if (subs[k].recruitBadgeKey && subs[k].hasPermission) {
              return true
            }
          }
        }
      }
      return false
    },
    loadRecruitBadges () {
      if (!this.hasRecruitBadgeMenu()) {
        return
      }
      let self = this
      self.$http.post('/tchRecruit/interview/summary', {}, { silent: true }).then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.recruitBadges = {
            interviewing: self.hrBadgeNum(res.data.interviewing),
            reserved: self.hrBadgeNum(res.data.reserved)
          }
        }
      }).catch(function () {})
    },
    hrBadgeNum (v) {
      let n = Number(v)
      if (!isFinite(n) || n <= 0) {
        return 0
      }
      return Math.floor(n)
    }
  }
}

</script>



// WEBPACK FOOTER //
// LeftMenu.vue?d0a3c186